export default __webpack_public_path__ + "static/media/Niramit-SemiBoldItalic.4c3420f4.ttf";